function updateHeaderTransparency() {
  // PERFORMANCE FIX: requestAnimationFrame prevents Layout Thrashing and TBT spikes
  requestAnimationFrame(() => {
    const header = document.querySelector('header');
    const mainContent = document.getElementById('MainContent');
    
    // Safety check to prevent console errors
    if (!header || !mainContent) return;

    const firstSection = mainContent.firstElementChild;
    if (!firstSection) return;

    // getComputedStyle is heavy, wrapping it here ensures it runs off the critical path
    const topSpacer = getComputedStyle(firstSection).getPropertyValue('--topSpacer');
    const hasTransparent = !!firstSection.querySelector('[allow-header-transparent]');

    header.classList.toggle('header-transparent', hasTransparent);

    const headerMainWrapper = document.querySelector('[header-main-wrapper]');

    if (hasTransparent) {
      if (headerMainWrapper) headerMainWrapper.classList.remove('section-spacing');
      header.classList.add('section-spacing');
      document.body.style.setProperty('--headerMargin', `${topSpacer}`);
    } else {
      if (headerMainWrapper) headerMainWrapper.classList.add('section-spacing');
      header.classList.remove('section-spacing');
    }
  });
}

// PERFORMANCE FIX: Delay execution until DOM is ready to prevent blocking the initial paint
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', updateHeaderTransparency);
} else {
  updateHeaderTransparency();
}